<cs-icon-button
  class="btn-back"
  iconType="icon"
  icon="fi-arrow-left"
  color="secondary"
  size="12"
  (buttonClick)="goBack()"
></cs-icon-button>
<div class="heading">Address QR</div>
<div class="cont">
  <div class="qr-code">
    @if (walletService.preservedDepositState) {
      <qr-code
        value="{{ walletService.preservedDepositState.depositAddress.address }}"
        size="256"
        errorCorrectionLevel="M"
      ></qr-code>
    }
  </div>
  <cs-button label="Back to Deposit" size="large" color="accent" (buttonClick)="goBack()"></cs-button>
</div>
